export const manageTaskProcessTypes = Object.freeze({
  JOIN: "join",
  REMOVE: "remove",
});
